import { cn } from '../utils'

function Skeleton({
  className,
  loading,
  asChild,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { loading: boolean; asChild?: boolean }) {
  return loading ? (
    <span {...props} className={cn('bg-grey-600/60 rounded-md opacity-20', className)}>
      <span aria-hidden className="opacity-0">
        X
      </span>
    </span>
  ) : asChild ? (
    children
  ) : (
    <span>{children}</span>
  )
}

export { Skeleton }
